import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useState, useEffect } from 'react';
import { utils } from '@atlaskit/util-service-support';
import { timed } from '../../common/clients';
import { SimpleCache } from '../../utils/simple-cache';
import { useJiraSearchClientContext } from './jira-search-provider';
const USER_DATA_URL = '/rest/api/3/user';
export class JiraCurrentUserClient {
  constructor({
    accountId,
    baseUrl,
    currentUserSupplier
  }) {
    _defineProperty(this, "getCurrentUser", () => this.currentUserCache.get().value);
    _defineProperty(this, "getUserSupplier", async () => {
      const {
        result,
        durationMs
      } = await this.makeRequest(USER_DATA_URL);
      return {
        ...result,
        timings: durationMs
      };
    });
    this.serviceConfig = {
      url: baseUrl
    };
    this.accountId = accountId;
    this.currentUserCache = new SimpleCache(currentUserSupplier || this.getUserSupplier);
  }
  async makeRequest(path) {
    const options = {
      path,
      queryParams: {
        accountId: this.accountId,
        expand: 'applicationRoles'
      }
    };
    return timed(utils.requestService(this.serviceConfig, options));
  }
}
export const useJiraCurrentUser = (user = {}) => {
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);
  const {
    currentUserClient
  } = useJiraSearchClientContext();
  useEffect(() => {
    if (!loadingComplete) {
      let shouldUpdate = true;
      currentUserClient === null || currentUserClient === void 0 ? void 0 : currentUserClient.getCurrentUser().then(result => {
        if (shouldUpdate && !loadingComplete) {
          setCurrentUser({
            id: result.accountId,
            name: result.displayName,
            avatarUrl: result.avatarUrls['24x24'],
            email: result.emailAddress,
            hasSoftwareAccess: result.applicationRoles.items.some(item => item.key === 'jira-software')
          });
          setLoadingComplete(true);
        }
      }).catch(() => {}); // swallow any errors

      return () => {
        shouldUpdate = false;
      };
    }
  }, [currentUserClient, loadingComplete]);
  return currentUser;
};